import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Grid, AddInvoice, EditInvoice, DialogContact, makeStyles } from "../../../..";
var useStyles = makeStyles(function (theme) {
  return {
    charts: {
      display: "flex",
      "justify-content": "space-between",
      padding: "25px",
      "flex-direction": "column"
    },
    contact: {
      background: "#ededed45",
      borderRadius: "4px"
    },
    mb30: {
      "margin-bottom": "30px"
    },
    edit: {
      color: theme.palette.pending.main
    }
  };
});

var InvoiceSingle = function InvoiceSingle(props) {
  var info = props.info,
      variant = props.variant,
      invoice = props.invoice,
      translation = props.translation,
      createInvoice = props.createInvoice,
      editInvoice = props.editInvoice,
      handleCancelEdit = props.handleCancelEdit,
      drawerOpen = props.drawerOpen,
      franchise = props.franchise,
      handleCreateClient = props.handleCreateClient,
      createContact = props.createContact,
      editContact = props.editContact,
      getContactInfo = props.getContactInfo,
      locale = props.locale; // console.log("InvoiceSingle props", props);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openContact = _useState2[0],
      setOpenContact = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openEditContact = _useState4[0],
      setOpenEditContact = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedContact = _useState6[0],
      setSelectedContact = _useState6[1];

  var handleDialogContact = function handleDialogContact() {
    setOpenContact(!openContact);
  };

  var handleDialogEditContact = function handleDialogEditContact(values) {
    if (!openEditContact) {
      // const client = info.clients.find(client => client._id === values._id);
      getContactInfo(values.value).then(function (response) {
        setSelectedContact(_objectSpread({}, response.data));
        setOpenEditContact(!openEditContact);
      });
    } else {
      setSelectedContact(null);
      setOpenEditContact(!openEditContact);
    }
  };

  var handleCreateContact = function handleCreateContact(values) {
    // console.log("handleCreateContact", values);
    createContact(values); // console.log(values);
  };

  var handleUpdateContact = function handleUpdateContact(values) {
    // console.log("handleUpdateContact", values);
    editContact(values); // console.log(values);
  };

  var content = function content(variant) {
    switch (variant) {
      case "add":
        return /*#__PURE__*/React.createElement(AddInvoice, {
          key: "add-invoice",
          type: franchise ? "out" : "in",
          variant: variant,
          info: info,
          createInvoice: createInvoice,
          drawerOpen: drawerOpen,
          franchise: franchise,
          createBillingInfo: function createBillingInfo(values) {
            handleDialogEditContact(values); // ;
          },
          handleCreateClient: function handleCreateClient(values) {
            handleDialogContact(); // handleCreateContact(values);
          },
          translation: translation ? translation : null,
          locale: locale
        });

      case "edit":
        return /*#__PURE__*/React.createElement(EditInvoice, {
          key: "edit-invoice",
          type: franchise ? "out" : "in",
          variant: variant,
          info: info,
          invoice: invoice,
          editInvoice: editInvoice,
          handleCancel: handleCancelEdit,
          drawerOpen: drawerOpen,
          createBillingInfo: function createBillingInfo(values) {
            handleDialogEditContact(values); // ;
          },
          handleCreateClient: function handleCreateClient(values) {
            handleDialogContact(); // handleCreateContact(values);
          },
          franchise: franchise,
          translation: translation ? translation : null,
          locale: locale
        });

      default:
        return /*#__PURE__*/React.createElement(AddInvoice, {
          key: "add-invoice-default",
          type: franchise ? "out" : "in",
          variant: variant,
          info: info,
          createInvoice: createInvoice,
          drawerOpen: drawerOpen,
          createBillingInfo: function createBillingInfo(values) {
            handleDialogEditContact(values); // ;
          },
          handleCreateClient: function handleCreateClient(values) {
            handleDialogContact(); // handleCreateContact(values);
          },
          franchise: franchise,
          translation: translation ? translation : null,
          locale: locale
        });
    }
  };

  return [/*#__PURE__*/React.createElement(DialogContact, {
    key: "add-contact",
    open: openContact,
    onClose: handleDialogContact,
    variant: "add",
    createContact: handleCreateContact,
    translation: translation ? translation.dialogs.add_contact : null
  }), /*#__PURE__*/React.createElement(DialogContact, {
    key: "edit-contact",
    open: openEditContact,
    onClose: handleDialogEditContact,
    variant: "edit",
    contact: selectedContact,
    editContact: handleUpdateContact,
    translation: translation ? translation.dialogs.add_contact : null //checked

  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      marginBottom: "32px"
    }
  }, content(variant)))];
};

export { InvoiceSingle };